export const CHECKOUT_URL = 'https://matematicapronta.impultienda.ar/checkout'
